import { NavigateNext as NavigateNextIcon } from '@material-ui/icons';
import { t } from '@lingui/macro';

import { Action } from './Actions';
import { useCanPanForward } from '../../../stores/TimeRangeHistoryStore';
import { useTimeRangeNavigation } from '../../../utilities/TimeRangeNavigationUtilities';

export default function PanForwardAction(props) {
    const [canPanForward] = useCanPanForward();
    const { enabled, panForward } = useTimeRangeNavigation();

    return enabled ? (
        <Action
            icon={<NavigateNextIcon />}
            tooltip={t`Pan the time range forwards`}
            disabled={!canPanForward}
            onClick={panForward}
            {...props}
        />
    ) : null;
}
